import { searchRoutes } from ".";
import { Routes } from "../common/routes/routes";
import { listingsBreakdownRoute, officeBreakdownRoute, officeListingsRoute } from "../market-dynamics/constants/routes";
import { urlPlatformAuth, urlPlatformConnection, urlPlatformHome, urlPlatformLaunch } from "./service";

export const navigateToPlatformConnection = (lwid) => window.location.replace(urlPlatformConnection(lwid));

export const navigateToPlatformUI = () => window.location.replace(urlPlatformLaunch);

export const navigateToPlatformHome = () => window.location.replace(urlPlatformHome);

export const navigateToLogin = () => window.location.replace(Routes.AUTH.LOG_IN);

export const navigateToLogout = () => window.location.replace(Routes.AUTH.LOG_OUT);

export const navigateToAuth = () => window.location.replace(Routes.AUTH.BASE);

export const navigateToPlatformAuth = (authParams) => window.location.replace(urlPlatformAuth(authParams));

export const navigateToHome = () => window.location.replace(Routes.HOME.BASE);

export const navigateToHomeAndReload = (history) => {
    history.replace(Routes.HOME.BASE);
    location.reload();
};

export const routesToShowBackNavBar = [
    officeBreakdownRoute,
    listingsBreakdownRoute,
    officeListingsRoute,
    searchRoutes.agentsGainedBreakdown,
    searchRoutes.officeListBreakdown,
];

export const constant = (title) => () => title;

export const createNavConfig = (backLinkTitle, constant) => ({
    backLinkTitle,
    getBackNavbarTitle: constant
});

export const formatPeriodTitle = (period, valueFormatter) => {
    return valueFormatter(period);
};

export const navigateToValidation = history => history.replace(Routes.VALIDATION.BASE);

export const navigateToVerificationError = history => history.replace(Routes.AUTH.VERIFICATION_ERROR);

export const routesToHideNavBar = [
    Routes.VALIDATION.BASE,
    Routes.AUTH.VERIFICATION_ERROR,
];

export const helpItemLabels = Object.freeze({
    WEBINARS_TRAINING: 'Webinars/Training',
    VIDEO_LIBRARY: 'Video Library',
    HELP_GUIDES_FAQS: 'Help Guides/FAQs',
});

export const talentTerms = Object.freeze({
    tryTalent: 'Try Talent',
    talent: 'Talent',
});

export const TALENT_MARKETING_URL = 'https://get.lwolf.com/brokermetrics-vip';
